
export const mockPartners = [
  {
    id: '1',
    name: 'WPEngine',
    logo: 'ri-server-line',
    logoColor: 'text-teal-600',
    logoBg: 'bg-teal-50',
    category: 'Web Hosting',
    status: 'active',
    commissionType: 'Recurring',
    commissionRate: '35%',
    negotiatedPrice: '$200/sale',
    cookieDuration: '180 days',
    paymentSchedule: 'Monthly',
    nextPayout: '2025-04-01',
    totalEarned: 14260,
    contractStart: '2024-01-15',
    contractEnd: '2025-01-15',
    affiliatePortalUrl: 'https://my.wpengine.com/affiliates',
    loginEmail: 'affiliate@mybusiness.com',
    loginPassword: '••••••••••',
    contactName: 'Sarah Mitchell',
    contactEmail: 'sarah.m@wpengine.com',
    contactPhone: '+1 (512) 555-0142',
    notes: 'Negotiated higher rate after hitting 50 sales/month. Renewal discussion scheduled for Dec 2024. They offered bonus $50 per enterprise referral.',
    contractFile: 'WPEngine_Affiliate_Agreement_2024.pdf',
    tags: ['hosting', 'wordpress', 'recurring'],
    monthlyStats: [1200, 980, 1450, 1100, 1680, 1320]
  },
  {
    id: '2',
    name: 'ConvertKit',
    logo: 'ri-mail-send-line',
    logoColor: 'text-rose-600',
    logoBg: 'bg-rose-50',
    category: 'Email Marketing',
    status: 'active',
    commissionType: 'Recurring',
    commissionRate: '30%',
    negotiatedPrice: '$150/sale + 30% recurring',
    cookieDuration: '90 days',
    paymentSchedule: 'Monthly',
    nextPayout: '2025-04-15',
    totalEarned: 9840,
    contractStart: '2024-03-01',
    contractEnd: '2025-03-01',
    affiliatePortalUrl: 'https://app.convertkit.com/affiliate',
    loginEmail: 'affiliate@mybusiness.com',
    loginPassword: '••••••••••',
    contactName: 'James Rodriguez',
    contactEmail: 'james.r@convertkit.com',
    contactPhone: '+1 (615) 555-0198',
    notes: 'Great conversion rates on creator audience. They provide custom landing pages for top affiliates. Ask about Q2 promo codes.',
    contractFile: 'ConvertKit_Partner_Contract.pdf',
    tags: ['email', 'creators', 'recurring'],
    monthlyStats: [800, 1100, 950, 1300, 1050, 1200]
  },
  {
    id: '3',
    name: 'Ahrefs',
    logo: 'ri-search-eye-line',
    logoColor: 'text-orange-600',
    logoBg: 'bg-orange-50',
    category: 'SEO Tools',
    status: 'active',
    commissionType: 'Recurring',
    commissionRate: '20%',
    negotiatedPrice: '$40-$200/sale recurring',
    cookieDuration: '60 days',
    paymentSchedule: 'Monthly',
    nextPayout: '2025-04-10',
    totalEarned: 7650,
    contractStart: '2024-02-10',
    contractEnd: '2025-02-10',
    affiliatePortalUrl: 'https://ahrefs.com/affiliate',
    loginEmail: 'seo@mybusiness.com',
    loginPassword: '••••••••••',
    contactName: 'Lisa Chen',
    contactEmail: 'lisa.c@ahrefs.com',
    contactPhone: '+65 555-0234',
    notes: 'Standard affiliate program. Trying to negotiate higher tier. Need 100+ referrals for premium rate. Currently at 78.',
    contractFile: null,
    tags: ['seo', 'analytics', 'recurring'],
    monthlyStats: [600, 750, 820, 900, 1100, 980]
  },
  {
    id: '4',
    name: 'Unbounce',
    logo: 'ri-layout-masonry-line',
    logoColor: 'text-indigo-600',
    logoBg: 'bg-indigo-50',
    category: 'Landing Pages',
    status: 'active',
    commissionType: 'Recurring',
    commissionRate: '20%',
    negotiatedPrice: '$50-$120/sale recurring',
    cookieDuration: '90 days',
    paymentSchedule: 'Monthly',
    nextPayout: '2025-04-05',
    totalEarned: 5430,
    contractStart: '2024-04-01',
    contractEnd: '2025-04-01',
    affiliatePortalUrl: 'https://unbounce.com/partner-portal',
    loginEmail: 'partner@mybusiness.com',
    loginPassword: '••••••••••',
    contactName: 'Mike Thompson',
    contactEmail: 'mike.t@unbounce.com',
    contactPhone: '+1 (604) 555-0311',
    notes: 'Renewal coming up in April. They mentioned a new tiered commission structure. Schedule call to discuss upgrade to premium partner.',
    contractFile: 'Unbounce_Affiliate_Terms_2024.pdf',
    tags: ['landing-pages', 'conversion', 'recurring'],
    monthlyStats: [450, 520, 680, 710, 890, 1020]
  },
  {
    id: '5',
    name: 'Canva Pro',
    logo: 'ri-palette-line',
    logoColor: 'text-cyan-600',
    logoBg: 'bg-cyan-50',
    category: 'Design Tools',
    status: 'paused',
    commissionType: 'One-time',
    commissionRate: '25%',
    negotiatedPrice: '$36/sale one-time',
    cookieDuration: '30 days',
    paymentSchedule: 'Monthly',
    nextPayout: 'N/A',
    totalEarned: 3240,
    contractStart: '2024-05-15',
    contractEnd: '2024-11-15',
    affiliatePortalUrl: 'https://www.canva.com/affiliates',
    loginEmail: 'design@mybusiness.com',
    loginPassword: '••••••••••',
    contactName: 'Amy Nguyen',
    contactEmail: 'amy.n@canva.com',
    contactPhone: '+61 555-0456',
    notes: 'Paused due to low conversion rates on our audience. Revisit in Q2 with new content strategy targeting small business owners.',
    contractFile: 'Canva_Affiliate_Agreement.pdf',
    tags: ['design', 'creative', 'one-time'],
    monthlyStats: [320, 280, 410, 350, 190, 0]
  },
  {
    id: '6',
    name: 'Monday.com',
    logo: 'ri-calendar-check-line',
    logoColor: 'text-emerald-600',
    logoBg: 'bg-emerald-50',
    category: 'Project Management',
    status: 'active',
    commissionType: 'One-time',
    commissionRate: '100% first month',
    negotiatedPrice: 'Up to $1,000/sale',
    cookieDuration: '90 days',
    paymentSchedule: 'Monthly',
    nextPayout: '2025-04-20',
    totalEarned: 11200,
    contractStart: '2024-01-01',
    contractEnd: '2025-12-31',
    affiliatePortalUrl: 'https://monday.com/affiliate-program',
    loginEmail: 'affiliate@mybusiness.com',
    loginPassword: '••••••••••',
    contactName: 'David Katz',
    contactEmail: 'david.k@monday.com',
    contactPhone: '+972 555-0789',
    notes: 'Excellent payout structure. Focus on enterprise leads for maximum commission. They provide co-branded webinar opportunities.',
    contractFile: 'Monday_Partner_Agreement_2024.pdf',
    tags: ['project-management', 'enterprise', 'high-ticket'],
    monthlyStats: [1800, 2100, 1500, 1900, 2400, 1800]
  }
];
